/* istanbul ignore file */

import type { Client } from 'urql';

import type {
  LocationsSearchByAreaQuery,
  LocationsSearchByAreaQueryVariables,
} from '../../graphql/LocationsSearchByArea.generated';
import { LocationsSearchByAreaDocument } from '../../graphql/LocationsSearchByArea.generated';
import type {
  LocationsSearchBySearchStringQuery,
  LocationsSearchBySearchStringQueryVariables,
} from '../../graphql/LocationsSearchBySearchString.generated';
import { LocationsSearchBySearchStringDocument } from '../../graphql/LocationsSearchBySearchString.generated';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Queries locations list based on provided search string
 */
export async function locationsSearchByStringQuery(
  client: Client,
  variables: LocationsSearchBySearchStringQueryVariables,
) {
  const { searchString } = variables;
  const queryLocations = client.query<LocationsSearchBySearchStringQuery>;

  return queryLocations(
    LocationsSearchBySearchStringDocument,
    { searchString },
    { requestPolicy: 'cache-and-network' },
  ).toPromise();
}

/**
 * Queries locations based on provided search area
 */
export async function locationsSearchByAreaQuery(
  client: Client,
  variables: LocationsSearchByAreaQueryVariables,
) {
  const queryLocations = client.query<LocationsSearchByAreaQuery>;

  return queryLocations(LocationsSearchByAreaDocument, variables, {
    requestPolicy: 'cache-and-network',
  }).toPromise();
}
